// extracted by mini-css-extract-plugin
export default {"navbar":"Nav_navbar__sGvIz","opacity-0":"Nav_opacity-0__6NQ-7","opacity-100":"Nav_opacity-100__5z485"};